<div [formGroup]="formGroup" class="mb-1">
<div class="mb-2">
    <div class="d-flex justify-content-arround">
      <div class="w-50">
        <label class="form-label">{{label}}<span *ngIf="isRequired"> * </span></label>  
        <ng-content></ng-content>
      </div>
      <div class="w-50">
          <div *ngIf="hasError()" class="invalid-feedback d-block text-end">
              {{ getErrorMessage() }}
          </div>
          <div *ngIf="isValid()" class="valid-feedback d-block text-end">
             
          </div>
      </div>
  </div>
  <div class="input-group flex-nowrap position-relative">      
      <span  [ngClass]="code +' input-group-text groupText'"  id="basic-addon1">{{htmlCode}}</span>
     
      <input
        [type]="type === 'password' && !showPassword ? 'password' : 'text'"
        class="form-control"
        [name]="formName" 
        [formControlName]="formControlValue" 
        [placeholder]="label"
        aria-label="name"
        autocomplete="off"
        aria-describedby="basic-addon1"
        [readonly] = "isReadonly"
        [maxlength]="maxlength"
      />
      <span
      *ngIf="type === 'password'"
      class="position-absolute eye-icon"
      (click)="togglePasswordVisibility()"
      style="cursor: pointer; right: 10px; top: 50%; transform: translateY(-50%);"
        >
      <i [class]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
    </span>
    </div>
  </div>
</div>